export enum ComponentType {
    TOS_SERVICE = 'tos-service',
    IDENTYUM_SERVICE = 'identyum-service',
    BLACKLIST_CHECKER = 'blacklist-checker',
    PSD2_SERVICE = 'psd2-service',
    AML_QUESTIONNAIRE = 'aml-questionnaire',
    LOAN_CONFIGURATOR = 'loan-configurator',
    DOCUMENTS = 'kentDocumentationService',
}
